import React from 'react'
import styles from './modal.module.css'
import wirWunderLogo from '../../../assets/images/logos/wirwunder_logo.svg'
import { MatchingEvent } from './types'
import { TrustedHtml } from 'shared'

export const ModalContent = ({
  matchingEvent,
  onHide,
  donateButton,
}: {
  matchingEvent: MatchingEvent
  onHide: React.MouseEventHandler<HTMLButtonElement>
  donateButton: React.ReactNode
}): JSX.Element => {
  const backgroundColor = matchingEvent.backgroundColor
  const customLogo = matchingEvent.logo

  return (
    <div className={styles.container}>
      <div data-testid="matching-event-modal-content" className={styles.logoContainer} style={{ backgroundColor }}>
        <img className={styles.logo} src={customLogo || wirWunderLogo} alt="" />
        {!customLogo && matchingEvent.branchLogo && (
          <img className={styles.logo} src={matchingEvent.branchLogo} alt="" />
        )}
      </div>
      <div>
        <TrustedHtml as="p" value={matchingEvent.modalDuration} />
        <TrustedHtml as="p" value={matchingEvent.modalBudget} />
        <TrustedHtml as="p" value={matchingEvent.modalMaximumAmount} />
        <TrustedHtml as="p" value={matchingEvent.modalFurtherInfo} className={styles.furtherInfo} />
        {matchingEvent.modalExtraInfo && <TrustedHtml as="p" value={matchingEvent.modalExtraInfo} />}
      </div>
      <div className={styles.buttons}>
        <button type="button" className="simulated-link" onClick={onHide}>
          <span>{i18n.t('misc.close')}</span>
        </button>
        {donateButton}
      </div>
    </div>
  )
}
